import SimpleDate from 'app/common/classes/simple-date'
import { ID } from 'app/common/ui-next/_filter-compilations/predefined-ids'
import { FinanceReportType } from 'app/dataTypes/reports/finances'
import { dateFormat as apiDateFormat } from '../../post'
import { encashmentsDateFormat } from 'app/dataTypes/reports/data'

export type ApiEncashmentsParams = {
  report_type: string
  params: {
    date: string,
    status: Array<number>,
    limits: {
      school_ids: Array<number>, // id школ
    },
  }
}

const statusParams = {
  cashAccepted: 0, //'Наличные приняты'
  cashRefused: 1, //'Отказано'
  waitingForCash: 2, //'Ожидает принятия наличных'
  cashNotDeposited: -1 //'Наличные не сданы'
}

const getFormDataStatusSelector = (formItem: ID, formData: FormData) => {
  const value = formData.getAll(ID.encashmentsStatus) as string[]
  if (value && value.length) return value
  return []
}

const getFormDataOrgsSelector = (formItem: ID, formData: FormData) => {
  const value = formData.getAll(formItem) as Array<string> | undefined
  if (value && value.length) return value
  return []
}

export const convertParams = (formData: FormData): [ApiEncashmentsParams, null] => {
  const date = formData.get(ID.date) as string
  const encashmentsStatuses = getFormDataStatusSelector(ID.encashmentsStatus, formData)
  const orgIDs = getFormDataOrgsSelector(ID.org, formData)

  return [{
    report_type: FinanceReportType.Encashments,
    params: {
      date: new SimpleDate(date, encashmentsDateFormat).getString(apiDateFormat),
      status: encashmentsStatuses.map(item => statusParams[item]),
      limits: {
        school_ids: orgIDs.map((id) => parseInt(id, 10))
      }
    },
  }, null]
}
